import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

import { Footer } from "@/components/layout/Footer";
import { Navbar } from "@/components/layout/Navbar";
import { isLocale, localeMeta } from "@/i18n/locales";

export const Route = createFileRoute("/$locale")({
  beforeLoad: ({ params }) => {
    if (!isLocale(params.locale)) {
      throw notFound();
    }
  },
  head: ({ params }) => ({
    meta: isLocale(params.locale)
      ? [{ name: "language", content: localeMeta[params.locale].html }]
      : [],
  }),
  component: LocaleLayout,
});

function LocaleLayout() {
  const { locale } = Route.useParams();

  if (!isLocale(locale)) {
    throw notFound();
  }

  return (
    <div className="min-h-screen font-body">
      <Navbar locale={locale} />
      <Outlet />
      <Footer locale={locale} />
    </div>
  );
}
